
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    prefixCls: {
      type: String,
      default: 'ant-pro',
    },
  },
  setup(props: any, { slots }: any) {
    const hasContent = slots.content;
    const hasExtraContent = slots.extraContent;

    return {
      hasContent,
      hasExtraContent,
      prefixedClassName: props.prefixCls,
    };
  },
});
